/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import CardC from "../../../components/CustomCard/CardC";
import Datatable from "../../../components/Datatable/Datatable";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { Loader, toaster } from "rsuite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import Form from "./Form";
import { Button } from "react-bootstrap";
import createURL from "../../../libs/peticiones/url";
import { useStore } from "../../../context/AppContext";
import { checkPermission } from "../../../libs/menuPermissions/permissions";
import { Region } from "../../../types/compl-archivos/Region";

export default function Regiones() {
    const [loading, setLoading] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [selected, setSelected] = useState<Region|undefined>();
    const { state } = useStore();

    async function getData(order: string, records: number, page: number, search: string){
        const url = createURL("/regiones", [
            {name: "order", value: order},
            {name: "records", value: records},
            {name: "page", value: page},
            {name: "search", value: search}
        ]);
        const res = await peticionBack({}, url, "GET", false, toaster);
        return res;
    }
    
    /* TABLA */
    const columns = [
        {data: "name"},
        {
            data: null, 
            render: (row: Region)=>(
                <div className="d-flex justify-content-evenly">
                    {checkPermission(state, "update") &&  <FontAwesomeIcon icon={faPencil} className="text-warning cursor-pointer" onClick={()=>openToEdit(row)} />}
                    {checkPermission(state, "delete") && <FontAwesomeIcon 
                        icon={faTrashCan} 
                        className="text-danger cursor-pointer" 
                        onClick={
                            ()=>swalAction(
                                deleteRow, 
                                "Eliminar región", 
                                `¿Desea eliminar la región ${row.name}?`, 
                                "question", 
                                row._id, 
                                "Eliminar"
                            )
                        } 
                    />}
                </div>
            )
        }
    ];

    const columnDefs = [
        {orderable: false, targets: [1]}
    ]

    async function deleteRow(id: number){
        setLoading(true);
        const res = await peticionBack({}, `/regiones/${id}`, "DELETE", true, toaster);
        if(res) setRefresh(true);
        setLoading(false);
    }

    function openToEdit(row: Region){ setSelected(row); }

    useEffect(()=>{
        if(selected) setOpen(true);
    }, [selected]);

    useEffect(()=>{
        if(!open){
            if(selected) {
                setSelected(undefined);
            }
        }
    }, [open]);
    
    return (
        <CardC>
            <div className="d-flex flex-column flex-md-row justify-content-md-between mb-2">
                <h4 className="">Regiones {open && (selected? "- Editar" : "- Agregar")}</h4>
                {!open && checkPermission(state, "create") && <Button onClick={()=>setOpen(true)} className="my-1 my-md-0">Agregar</Button>}
            </div>
            {
                open ? 
                    <Form setOpen={setOpen} selected={selected} /> :
                    checkPermission(state, "read") && <Datatable
                        columns={columns}
                        headers={["Nombre", "Acciones"]}
                        columnDefs={columnDefs}
                        petition={getData}
                        control="back"
                        stateRefresh={[refresh, setRefresh]}
                        className="p-0"
                    />
            }
            { loading && <Loader backdrop vertical style={{zIndex: 5}} /> }
        </CardC>
    );
}
